"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlsJSPlayer = void 0;
var hls_js_1 = __importDefault(require("hls.js"));
var HlsJSPlayer = /** @class */ (function () {
    function HlsJSPlayer() {
        var _this = this;
        this.play = function () {
            _this.video.play();
        };
        this.pause = function () {
            _this.video.pause();
        };
        this.seekTo0 = function () {
            _this.video.currentTime = 0;
        };
        this.attachEvent = function (event, callback) {
            _this.video.addEventListener(event, callback);
        };
        this.detachEvent = function (event, callback) {
            _this.video.removeEventListener(event, callback);
        };
        this.load = function (src) {
            _this.player.loadSource(src);
        };
        this.audioTracks = function () {
            var _a;
            return (_a = _this.player) === null || _a === void 0 ? void 0 : _a.audioTracks.map(function (t) { return (__assign(__assign({}, t), { language: t.lang })); });
        };
        this.textTracks = function () {
            var _a;
            return (_a = _this.player) === null || _a === void 0 ? void 0 : _a.subtitleTracks.map(function (t) { return (__assign(__assign({}, t), { language: t.lang })); });
        };
        this.video = document.createElement('video');
        this.video.setAttribute('id', 'player-tag');
        this.video.setAttribute('width', window.innerWidth.toString());
        this.video.setAttribute('height', window.innerHeight.toString());
        var videoContainer = document.getElementById('video');
        videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer.appendChild(this.video);
        this.player = new hls_js_1.default();
        this.player.attachMedia(this.video);
    }
    HlsJSPlayer.prototype.destroy = function () {
        this.video.pause();
        this.video.setAttribute('src', 'data:video/mp4;base64,AAAAHG...MTAw');
        this.video.load();
        this.video.remove();
    };
    return HlsJSPlayer;
}());
exports.HlsJSPlayer = HlsJSPlayer;
